import { useNavigate } from "react-router-dom";
import { useState } from "react";
import Page from "../Page";
import Button from "../../components/input/button";
import useSubmitGeneralFeedback from "../../hooks/feedback/useSubmitGeneralFeedback";
import { Snackbar, Alert, Typography } from "@mui/material";

const GeneralFeedbackPage = () => {
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const [feedback, setFeedback] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const { submit } = useSubmitGeneralFeedback();

  const handleSubmit = async () => {
    if (!feedback.trim()) {
      setSnackbarMessage("You must at least provide some feedback!");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    setSubmitting(true);

    const result = await submit({
      feedback,
    });

    setSubmitting(false);

    if (result.success) {
      setSnackbarMessage(
        "Message sent! You can view our response in your notifications.",
      );
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      // Clear form
      setFeedback("");
      // Navigate after a short delay to let user see the snackbar
      setTimeout(() => navigate("/feedback"), 1500);
    } else {
      setSnackbarMessage(`Failed to send message. Please try again later`);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  return (
    <Page className="feedback-page" pageKey="general-feedback">
      <Typography variant="pageTitleWhite" className="feedback-page_title">
        Say Hello 👋
      </Typography>

      <div className="feedback-page_panel">
        <Typography
          variant="formLabel"
          className="feedback-page_panel_input-label"
        >
          Send us a message and we'll get back to you.
        </Typography>
        <textarea
          className="feedback-page_panel_input-area"
          placeholder="Hi Mindstack team! I just wanted to say..."
          maxLength={2000}
          value={feedback}
          onChange={(e) => setFeedback(e.target.value)}
        />

        <Button
          color="orange"
          text="Send message"
          size="large"
          onClick={handleSubmit}
          loading={submitting}
          disabled={submitting}
        />
      </div>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Page>
  );
};

export default GeneralFeedbackPage;
